import apiHeader from '@/helpers/apiHeader';

const manageRoleService = {
    list(params) {
        return apiHeader.get('manage-account/manage-role', { params });
    },
    detail(id) {
        return apiHeader.get('manage-account/manage-role/' + id);
    },
    create(params) {
        return apiHeader.post('manage-account/manage-role', params);
    },
    update(id, params) {
        return apiHeader.put('manage-account/manage-role/' + id, params);
    },
    delete(id) {
        return apiHeader.delete('manage-account/manage-role/' + id);
    }
}

export default manageRoleService;